var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpvoteActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9993 13.9998H7.9993V20.9998C7.9993 21.265 8.10466 21.5194 8.29219 21.7069C8.47973 21.8944 8.73408 21.9998 8.9993 21.9998H14.9993C15.2645 21.9998 15.5189 21.8944 15.7064 21.7069C15.8939 21.5194 15.9993 21.265 15.9993 20.9998V13.9998H19.9993C20.1876 13.9995 20.3719 13.9461 20.5312 13.8457C20.6905 13.7454 20.8182 13.6021 20.8998 13.4324C20.9814 13.2627 21.0134 13.0735 20.9923 12.8864C20.9711 12.6993 20.8977 12.522 20.7803 12.3748L12.7803 2.3748C12.3993 1.8998 11.5993 1.8998 11.2183 2.3748L3.2183 12.3748C3.10094 12.522 3.02747 12.6993 3.00633 12.8864C2.98519 13.0735 3.01724 13.2627 3.09879 13.4324C3.18035 13.6021 3.3081 13.7454 3.46739 13.8457C3.62667 13.9461 3.81103 13.9995 3.9993 13.9998Z",
    fill: "#35C567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvoteActive);
export default __webpack_public_path__ + "static/media/upvote-active.1991d69467d06bc84d9dafee102422de.svg";
export { ForwardRef as ReactComponent };